import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_close.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-53214bb4")

_pushScopeId("data-v-53214bb4")
const _hoisted_1 = { class: "relative text-sm" }
const _hoisted_2 = { class: "flex items-center justify-between gap-3 overflow-hidden w-full px-4 py-2.5" }
const _hoisted_3 = { class: "flex overflow-hidden gap-3" }
const _hoisted_4 = {
  key: 0,
  class: "text-gray-lp-600 text-xs"
}
const _hoisted_5 = {
  key: 1,
  class: "overflow-hidden"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "overflow-ellipsis whitespace-nowrap overflow-hidden" }, " Semua dipilih ", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_8 = { class: "overflow-ellipsis whitespace-nowrap overflow-hidden" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_10 = {
  key: 3,
  class: "tags text-sm font-medium text-gray-lp-300"
}
const _hoisted_11 = { class: "max-h-72 overflow-y-auto" }
const _hoisted_12 = {
  key: 0,
  class: "pb-2 px-4"
}
const _hoisted_13 = {
  key: 1,
  class: "py-4 mb-2 text-gray-lp-300 text-center items-center"
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-300" }, "Pilih Semua", -1)
const _hoisted_16 = { class: "flex flex-row justify-between items-center w-full" }
const _hoisted_17 = { class: "text-gray-lp-300" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", {
      tabindex: "0",
      class: [
        'popup-button bg-white',
        _ctx.isDropdownVisible
          ? 'rounded-t-md border border-b-0'
          : 'rounded-md border',
        {
          'bg-gray-3 disabled': _ctx.disabled
        }
      ],
      "data-testid": "dropdown-multiselect__input",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickField && _ctx.onClickField(...args))),
      onKeypress: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onClickField && _ctx.onClickField(...args)), ["enter"]))
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_ctx.tempValue.length === 0 && !_ctx.isVirtualAllActive)
            ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.placeholder), 1))
            : (_ctx.isVirtualAllActive)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode("div", {
                    class: [
                'tags',
                'overflow-hidden',
                _ctx.disabled
                  ? 'opacity-50 cursor-not-allowed'
                  : 'opacity-100 cursor-pointer'
              ],
                    "data-testid": "dropdown-multiselect__virtual-all-tag",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSelectAll && _ctx.onSelectAll(...args)), ["prevent","stop"]))
                  }, [
                    _hoisted_6,
                    _hoisted_7
                  ], 2)
                ]))
              : (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList(_ctx.filteredTempValue, (name) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "overflow-hidden",
                    key: name,
                    "data-testid": `dropdown-multiselect__tag-${name}`,
                    onClick: _withModifiers(
            () => {
              _ctx.onRemoveItem(name)
            }
            , ["prevent","stop"])
                  }, [
                    _createVNode("div", {
                      class: [
                'tags',
                'overflow-hidden',
                _ctx.disabled
                  ? 'opacity-50 cursor-not-allowed'
                  : 'opacity-100 cursor-pointer'
              ]
                    }, [
                      _createVNode("div", _hoisted_8, _toDisplayString(_ctx.getValueLabel(name)), 1),
                      _hoisted_9
                    ], 2)
                  ], 8, ["data-testid", "onClick"]))
                }), 128)),
          (_ctx.isMax)
            ? (_openBlock(), _createBlock("div", _hoisted_10, " +" + _toDisplayString(_ctx.tempValue.length - _ctx.maxSelect), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Icons, {
          name: "chevron-right-thin",
          style: {"width":"6px"},
          class: ["text-gray-lp-600 transform", [
            {'rotate-90': !_ctx.isDropdownVisible},
            {'-rotate-90': _ctx.isDropdownVisible},
          ]]
        }, null, 8, ["class"])
      ])
    ], 34), [
      [_directive_click_outside, () => _ctx.onClickOutside()]
    ]),
    (_ctx.isDropdownVisible)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: [
        'absolute flex flex-col bg-white w-full z-50 p-1 border-grayPensive rounded-b-md shadow-xl',
        _ctx.isDropdownVisible ? 'border border-t-0' : 'border',
      ],
          onClick: _cache[7] || (_cache[7] = e => {
        e.stopPropagation()
      })
        }, [
          (_ctx.withSearch)
            ? (_openBlock(), _createBlock("input", {
                key: 0,
                class: "outline-none w-full px-4 py-2",
                type: "text",
                placeholder: _ctx.searchPlaceholder,
                value: _ctx.keyword,
                onFocus: _cache[4] || (_cache[4] = () => (!_ctx.isDisabled ? _ctx.onOpenSelect() : {})),
                onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onFilterOptions && _ctx.onFilterOptions(...args)))
              }, null, 40, ["placeholder", "value"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_11, [
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                  _createVNode(_component_Skeleton, {
                    height: "1.3rem",
                    width: "18.5rem",
                    class: "my-2"
                  }),
                  _createVNode(_component_Skeleton, {
                    height: "1.3rem",
                    width: "22.5rem",
                    class: "my-2"
                  })
                ]))
              : (
            _ctx.keyword ? _ctx.filteredOptions.length === 0 : _ctx.options.length === 0
          )
                ? (_openBlock(), _createBlock("div", _hoisted_13, " Apa yang Anda cari tidak ditemukan atau tidak ada. "))
                : (_openBlock(), _createBlock("ul", _hoisted_14, [
                    (_ctx.isWithChooseAll && !_ctx.keyword)
                      ? (_openBlock(), _createBlock("li", {
                          key: 0,
                          "data-testid": `dropdown-multiselect__option-select-all`,
                          class: "flex px-4 gap-4 py-2 items-center cursor-pointer",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onSelectAll && _ctx.onSelectAll(...args)))
                        }, [
                          _createVNode(_component_CheckBox, {
                            "data-testid": `dropdown-multiselect__checkbox-select-all`,
                            modelValue: _ctx.virtualAll ? _ctx.isAllSelected : _ctx.isSelectedAll,
                            binary: ""
                          }, null, 8, ["modelValue"]),
                          _hoisted_15
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.keyword ? _ctx.filteredOptions : _ctx.options, (option, i) => {
                      return (_openBlock(), _createBlock("li", {
                        key: `${option.value}-${i}`,
                        class: "flex px-4 gap-4 py-2 items-center cursor-pointer",
                        "data-testid": `dropdown-multiselect__option-${option.value}`,
                        onClick: () => _ctx.onSelectOption(option.value)
                      }, [
                        _createVNode(_component_CheckBox, {
                          "data-testid": `dropdown-multiselect__checkbox-${option.value}`,
                          modelValue: _ctx.isChecked(option.value),
                          binary: ""
                        }, null, 8, ["data-testid", "modelValue"]),
                        _createVNode("div", _hoisted_16, [
                          _createVNode("span", _hoisted_17, _toDisplayString(option.label), 1),
                          _renderSlot(_ctx.$slots, "default", { option: option }, undefined, true)
                        ])
                      ], 8, ["data-testid", "onClick"]))
                    }), 128))
                  ]))
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
})